"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builderToClass = builderToClass;
const Autocomplete_1 = require("./Autocomplete");
const Dropdown_1 = require("./Dropdown");
const Html_1 = require("./Html");
const Image_1 = require("./Image");
const ImageQuestion_1 = require("./ImageQuestion");
const MultiSelectQuestion_1 = require("./MultiSelectQuestion");
const RankedQuestion_1 = require("./RankedQuestion");
const SingleSelectQuestion_1 = require("./SingleSelectQuestion");
const SongsQuestion_1 = require("./SongsQuestion");
const Text_1 = require("./Text");
const TextQuestion_1 = require("./TextQuestion");
function builderToClass(builderModule) {
    switch (builderModule.type) {
        case "Autocomplete":
        case "TypeaheadQuestion":
            return new Autocomplete_1.AutocompleteModule(builderModule);
        case "Dropdown":
            return new Dropdown_1.DropdownModule(builderModule);
        case "Html":
            return new Html_1.HTMLModule(builderModule);
        case "image":
            return new Image_1.ImageModule(builderModule);
        case "ImageQuestion":
            return new ImageQuestion_1.ImageQuestionModule(builderModule);
        case "MultipleSelectQuestion":
            return new MultiSelectQuestion_1.MultiSelectQuestionModule(builderModule);
        case "RankedQuestion":
            return new RankedQuestion_1.RankedQuestionModule(builderModule);
        case "SingleSelectQuestion":
            return new SingleSelectQuestion_1.SingleSelectQuestionModule(builderModule);
        case "TextQuestion":
            return new TextQuestion_1.TextQuestionModule(builderModule);
        case "text":
            return new Text_1.TextModule(builderModule);
        case "SongsQuestion":
            return new SongsQuestion_1.SongsQuestionModule(builderModule);
        default:
            throw new Error(`unable to convert builder module ${builderModule.type} to class`);
    }
}
//# sourceMappingURL=resolve.js.map